import {Box} from '@mui/material';
import React, {FC} from 'react';

export const FlexColumn: FC<BoxProps> = React.memo((props) => {
  return (
    <Box display="flex" flexDirection="column" ref={props.boxref} {...props} >
      {props.children}
    </Box>
  );
});
